export enum CustomTooltipTypes {
	info = 'info',
	warning = 'warning',
	significant = 'significant',
	notSignificant = 'notSignificant',
	significanceNA = 'significanceNA',
}
